import Overlay from "../_overlay/_overlay.js";
import Nav from "./nav/nav.js";

class Menu extends Overlay {
	/**
	 * @param {HTMLElement} element
	 * @param {Function} callback
	 */
	constructor(element, callback) {
		super(element, callback);

		const nav = element.querySelector(".HeaderMenu-nav");

		if (nav) {
			this.nav = new Nav(nav);
		}
	}

	/**
	 * @param {boolean} isOpen
	 */
	onToggle(isOpen) {
		this.callback("menu", isOpen);
	}
}

export default Menu;
